import { useCallback, useEffect, useState } from "react";

// Returns [ships, refresh]. refresh() re-downloads the approved ships (e.g. after an admin approves one).
export default function useShips(API_BASE) {
  const [ships, setShips] = useState([]);

  const load = useCallback((fresh) => {
    fetch(`${API_BASE}/api/ships`, fresh ? { cache: "no-store" } : undefined)
      .then(res => res.json())
      .then(data => Array.isArray(data) && setShips(data))
      .catch(err => console.error("Failed to fetch ships:", err));
  }, [API_BASE]);

  useEffect(() => { load(false); }, [load]);

  const refresh = useCallback(() => load(true), [load]);
  return [ships, refresh];
}
